<template>
  <div>
    <div class="header mb-12px">
      <a class="header-logo" href="//www.jdcloud.com"></a>
    </div>

    <div class="jc-page-content" style="position: relative">
      <div class="jc-panel jc-panel-padding jc-panel-position">
        <div>
          <div class="jc-box-content text-center">
            <div class="mb-32px">
              <div>京东云合作伙伴</div>

              <!-- 西安星雾科技有限公司是2023.9.26云上峰会的商家，防止当天接口出问题，影响招商，先暂时写死做最后收底 -->
              <div class="font-600 text-18px mb-32px">
                {{ distributorName || '西安星雾科技有限公司' }}
              </div>

              <div class="font-600 text-24px">邀请您成为他的客户</div>
            </div>

            <div class="jc-box-action mt-16px">
              <div class="mb-16px">
                <el-button
                  style="height: 40px; width: 164px"
                  type="primary"
                  @click="goTo('//login.jdcloud.com')"
                  >登录关联已有京东云账号</el-button
                >
              </div>

              <div class="mb-16px">
                <el-button
                  style="height: 40px; width: 164px"
                  type="primary"
                  @click="goTo('//user.jdcloud.com/register')"
                  >注册新账号关联</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    distributorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    goTo(url) {
      let gotoUrl = `${url}?returnUrl=${encodeURIComponent(
        this.$route.query.returnUrl,
      )}`
      window.location.href = gotoUrl
    },
  },
}
</script>

<style scoped="true">
@media only screen and (max-width: 640px) {
  .header {
    z-index: 20;
    background: #ffffff;
    box-shadow: 0 3px 12px 0 #d1dbe5;
    height: 70px;
    background: #fff;
    padding: 0 33px;
    display: flex;
    justify-content: space-between;
  }
  .header-logo {
    width: 100%;
    background-image: url(https://menu.s3.cn-north-1.jdcloud-oss.com/logo_cn_b_t.png);
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 226px 40px;
    height: 70px;
    text-indent: -9999px;
    cursor: pointer;
  }
  .jc-page-content {
    padding: 0px;
    height: 100vh;
    background: #ffffff;
  }
  .jc-panel {
    border: none;
    margin-bottom: 10px;
    background-color: #fff;
  }
  .jc-panel-position {
    width: 100%;
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -30%);
  }
  .jc-panel.jc-panel-padding {
    padding: 12px;
  }
  .text-center {
    text-align: center;
  }
  .mb-12px {
    margin-bottom: 12px;
  }
  .mb-16px {
    margin-bottom: 16px;
  }
  .mb-32px {
    margin-bottom: 32px;
  }
  .mt-16px {
    margin-top: 16px;
  }
  .font-600 {
    font-weight: 600;
  }
  .text-18px {
    font-size: 18px;
  }
  .text-24px {
    font-size: 24px;
  }
}
</style>
